import * as React from "react";
import PropTypes from "prop-types";
import { getAbsoluteImagePath } from "@utils/dom";

interface SVGAmexProps extends React.HTMLAttributes<HTMLImageElement> {}

const SVGAmex: React.FC<SVGAmexProps> = ({ ...props }) => {
  return (
    <img
      src={getAbsoluteImagePath("/assets/img/icons/cards/ancv.jpg")}
      {...props}
    />
  );
};

SVGAmex.propTypes = {
  //
};

export default SVGAmex;
